import React, { useState } from "react";
import { Config } from "@config/config";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import ISelect from "@components/forms/ISelect";
const FormTypePrice = (props) => {
  const { t } = useTranslation();
  const config = new Config(t);
  const data = config.priceTypeOptions();

  var i = 1;
  if (props.room.priceType === "per_room") {
    i = 0;
  }

  const [loading, setLoading] = useState(false);
  const [priceTypeSelected, setPriceTypeSelected] = useState(data[i]);

  const onSubmit = async () => {
    setLoading(true);

    await props.changeTypePrice(
      props.room,
      props.index,
      priceTypeSelected.value
    );
    setLoading(false);
  };

  return (
    <>
      <Row>
        <Col md="12" className="mt-3">
          <span>{t("ho_act_detailscancelTarif")}</span>

          <ISelect
            id="priceType"
            name="priceType"
            label={t("ho_act_detailscancelTarif")}
            value={priceTypeSelected}
            handleChange={setPriceTypeSelected}
            data={data}
            isSearchable={false}
            isClearable={false}
          />
        </Col>
        <Col md="12" className="mt-3">
          <Form
            as="button"
            type="submit"
            className="btn-blue p-3 rounded-3 fw-bold w-100"
            onClick={onSubmit}
          >
            {loading ? (
              <Form
                as="span"
                className="spinner-border spinner-border-sm m-1 "
              ></Form>
            ) : (
              t("edit")
            )}
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default FormTypePrice;
